import $ from "jquery";
import { gsap } from "gsap";

export function fastlink_toggle() {
    this.fastlink_show = !this.fastlink_show;
    const fastlink_w = $('.fastlink_row').outerWidth(true);
    if (this.fastlink_show) {
        gsap.to(".fastlink", { duration: .3, x: 0, ease: 'power2.out' });
    } else {
        gsap.to(".fastlink", { duration: .3, x: fastlink_w, ease: 'power2.out' });
    }
}
